// Library categories — used for horizontal-scroll category pills.
// Actual article content lives in Supabase `articles` table and is fetched
// at runtime. This file only provides the canonical category list.

export const LIBRARY_CATEGORIES = [
  "All",
  "Skincare",
  "Haircare",
  "Ingredients",
  "Wellness",
  "DIY Tips",
];
